import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Fee/Pavatino.css';

function Pavatino() {
  const location = useLocation();
  const navigate = useNavigate();
  const [studentDetails, setStudentDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classCounts, setClassCounts] = useState({});
  const [allClassFees, setAllClassFees] = useState({});
  const [fetchedFeeDetails, setFetchedFeeDetails] = useState([]);
  const language = localStorage.getItem("language");
  const {
    year,
    selectedClass,
    division,
    schoolDetails,
    feeDetails,
    totalStudentCount,
    totalFeeAmount,
  } = location.state || {};

  console.log("feeDetails222", feeDetails);
  console.log("selectedClass22", selectedClass);
  console.log("division222", division);
  console.log("totalStudentCount222", totalStudentCount);

  const calculateFeePerStudent = () => {
    if (selectedClass === "All" && division === "All") {
      const totalFee = fetchedFeeDetails.reduce((sum, fee) => sum + Number(fee.amount), 0);
      return totalFee.toFixed(2); 
    } else if (selectedClass !== "All" && division === "All") {
      const filteredFees = fetchedFeeDetails.filter(
        (fee) => fee.classType === selectedClass || fee.classType === "All"
      );
      const totalFee = filteredFees.reduce((sum, fee) => sum + Number(fee.amount), 0);
      return totalFee.toFixed(2); 
    } else if (selectedClass !== "All" && division !== "All") {
   
      const filteredFees = fetchedFeeDetails.filter(
        (fee) => fee.classType === selectedClass || fee.classType === "All"
      );
      const totalFee = filteredFees.reduce((sum, fee) => sum + Number(fee.amount), 0);
      return totalFee.toFixed(2); 
    } else if (totalStudentCount > 0) {
     
      return (totalFeeAmount / totalStudentCount).toFixed(2);
    }
    return 0;
  };
  

  useEffect(() => {
    // Any additional data fetching or calculations
  }, [feeDetails]);

  const fetchData = async () => {
    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
    const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${year}.json`;

    try {
      const [studentResponse, feeResponse] = await Promise.all([
        fetch(studentUrl),
        fetch(feeUrl),
      ]);

      const studentData = await studentResponse.json();
      const feeData = await feeResponse.json();

      const studentArray = Object.keys(studentData || {}).map((key) => ({
        registerNo: key,
        ...studentData[key],
      })).filter(student=> student.isActive === true || student.isActive===undefined);

      // Calculate class counts
      const counts = {};
      studentArray.forEach((student) => {
        const cls = student.currentClass || 'Unknown';
        counts[cls] = (counts[cls] || 0) + 1;
      });

      setClassCounts(counts);
      setStudentDetails(studentArray);

      const feeEntries = [];
      const allClassFees = {};

      if (feeData) {
        Object.entries(feeData).forEach(([key, fee]) => {
          feeEntries.push({
            feeType: key,
            amount: fee.amount,
            classType: fee.classType,
          });

          if (fee.classType === 'All') {
            allClassFees[key] = fee.amount;
          }
        });
      }

      setFetchedFeeDetails(feeEntries);
      setAllClassFees(allClassFees);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [udiseNumber]);

  const filteredStudents = studentDetails.filter(student =>
    (selectedClass === "All" || student.currentClass == selectedClass) && 
    (division === 'All' || student.division == division)
  );
  const filteredStudentCount = filteredStudents.length;

  const calculateFeeTotals = () => {
    let totalDiscountAmount = 0;
    let totalBeforePay = 0;
    let totalRemainingAmount = 0;
  
    const filteredFees = fetchedFeeDetails.filter(fee => 
      fee.classType == selectedClass || fee.classType === 'All'
    );
    const runningTotal = filteredFees.reduce((sum, fee) => sum + Number(fee.amount), 0);
    
    const totalAmount = totalStudentCount * calculateFeePerStudent();
  
    if (feeDetails && Object.keys(feeDetails).length > 0) {
      Object.keys(feeDetails).forEach((serialNo) => {
        const invoiceNumbers = Object.keys(feeDetails[serialNo]);
        const lastInvoiceNo = invoiceNumbers[invoiceNumbers.length - 1];
  
        const feeKeys = Object.keys(feeDetails[serialNo][lastInvoiceNo]);
        feeKeys.forEach((feeKey) => {
          const feeData = feeDetails[serialNo][lastInvoiceNo][feeKey];
          if (feeData && feeKey !== "Bus Fee") {
            totalDiscountAmount += parseFloat(feeData.discountAmount) || 0;
            totalBeforePay += parseFloat(feeData.beforePay) || 0;
            totalRemainingAmount += parseFloat(feeData.remainingAmount) || 0;
          }
        });
      });
    }

    const perStudentAmount = filteredStudentCount > 0 ? (totalAmount / filteredStudentCount).toFixed(2) : 0;

    return {
      totalAmount: totalAmount.toFixed(2),
      perStudentAmount,
      totalDiscountAmount,
      totalBeforePay,
      totalRemainingAmountfinal: totalAmount - totalDiscountAmount,
      remainingFee: (totalAmount - totalDiscountAmount) - totalBeforePay,
      
    };
  };

  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype; // Return the part before the last '-' or the whole feetype if '-' is not found
  };
  const totals = calculateFeeTotals();

  const handlePrint = () => {
    const receiptContainer = document.querySelector('.receipt-container');
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(`
      <html>
        <head>
          <title>Class Fee Report</title>
          <style>
            .receipt-container {
              width: 1200px;
              margin: 40px auto;
              padding: 20px;
              background-color: #f9f9f9;
              border: 1px solid #ddd;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
               @page {
                size: A4 Portrait;
            margin: 3mm; /* this affects the margin in the printer settings */
          }
            .receipt-header {
              text-align: center;
              margin-bottom: 20px;
            }
            .taludis {
              text-align: left;
            }
            .receipt-header h1 {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .receipt-header h2 {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .receipt-header h3 {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .table-container {
              overflow-x: auto;
            }
            .receipt-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            .receipt-table th, .receipt-table td {
              border: 1px solid #ddd;
              padding: 10px;
              text-align: center;
            }
            .receipt-table th {
               background-color: #6495ED;  
               color: white;       
            }
            .receipt-table td {
              background-color: #fff;
            }
            body {
              border: 2px solid black;
              padding: 10px;
            }
          </style>
        </head>
        <body>
          ${receiptContainer.innerHTML}
          <script>
            window.print();
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };
  console.log("studentcount",totalStudentCount);
  

  return (
    <div className='main-content-of-page'>
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
        <button 
          onClick={handleGoBack} 
          style={{
            backgroundColor: '#FFFFFF',
            color: 'black',
            padding: '7px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '20px', // Space between buttons
            border: '1px solid black',
            marginTop: '20px',
            marginLeft: '30px',
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
          Go Back
        </button>
        <button 
          onClick={handlePrint} 
          style={{
            backgroundColor: '#6495ED',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginLeft: '10px', 
            marginTop: '20px'
          }}
        >
          Print Report
        </button>
      </div>
      <div className="receipt-container">
        <div className="receipt-header" style={{ border: '1px solid black', marginBottom: '10px', backgroundColor: '#F7F7F7', padding: '10px' }}>
          <h6>{schoolDetails?.sansthaName || ' '}</h6>
          <h1>{schoolDetails?.schoolName || ' '}</h1>
          <div className='taludis' style={{ textAlign: 'center' }}>
            <p>{language === "English" ? "Taluka:  " : "तालुका"} {schoolDetails?.taluka}, {language === "English" ? "District:  " : "जिल्हा"} {schoolDetails?.district}</p>
          </div>
          <h2 style={{
            display: 'block',
            border: '1px solid black',
            backgroundColor: 'black',
            color: 'white',
            padding: '5px',
            width: '200px',
            textAlign: 'center',
            margin: '0 auto',
            borderRadius: '10px'
          }}>
            {language === "English" ? "Class Fee Report:  " : "वर्ग फी अहवाल"}
          </h2>
        </div>
        <div>
          <p>{language === "English" ? "Year :  " : "आर्थिक वर्ष"} {year || ""}</p>
        </div>
        <div className="table-container">
          <table className="receipt-table">
            <thead>
              <tr>
                <th>{language === "English" ? "Class  " : "वर्ग"}</th>
                <th>{language === "English" ? "Division  " : "तुकडी"}</th>
                <th>{language === "English" ? "Student Count  " : "विद्यार्थी संख्या"}</th>
                <th>{language === "English" ? "Fee Per Student  " : "प्रति विद्यार्थी फी"}</th>
                <th>{language === "English" ? "Total Fee  " : "एकूण फी"}</th>
                <th>{language === "English" ? "Total Discount (rs)  " : "एकूण सवलत (रु.)"}</th>
                <th>{language === "English" ? "After Dis Fee  " : "सवलत फी नंतर"}</th>
                <th>{language === "English" ? "Paid Fee  " : "दिलेली फी"}</th>
                <th>{language === "English" ? "Remaining Fee  " : "उर्वरित फी"}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{selectedClass || ' '}</td>
                <td>{division || ' '}</td>
                <td>{totalStudentCount || '0'}</td>
                <td>{calculateFeePerStudent() || '0'}</td>
                <td>{totals.totalAmount || '0'}</td>
                <td>{totals.totalDiscountAmount || '0'}</td>
                <td>{totals.totalRemainingAmountfinal || '0'}</td>
                <td>{totals.totalBeforePay || '0'}</td>
                <td>{totals.remainingFee || '0'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Pavatino;